import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { JsonQuery, NonEmptyArray } from '../../../packages/JsonQuery';
import { getOffers } from 'shared/thunks/offers';
import { EDealType, EOffersStatus, IOffersState, ERoomType, TOffers } from 'shared/types/offers';
import { initialState } from './initialState';

const offersSlice = createSlice({
  initialState,
  name: 'offers',
  reducers: {
    setDealType: (state, action: PayloadAction<EDealType>) => {
      state.data.jsonQuery = new JsonQuery(state.data.jsonQuery).setDealType(action.payload).toJSON();
    },
    setRoomTypes: (state, action: PayloadAction<NonEmptyArray<ERoomType> | null>) => {
      state.data.jsonQuery = new JsonQuery(state.data.jsonQuery).setRoomTypes(action.payload).toJSON();
    },
    resetOffers: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getOffers.pending, state => {
        state.status = EOffersStatus.Pending;
      })
      .addCase(getOffers.fulfilled, (state, action: PayloadAction<IOffersState<TOffers>>) => {
        return {
          ...state,
          ...action.payload,
        };
      })
      .addCase(
        getOffers.rejected,
        /* istanbul ignore next */ (state, action) => {
          if (action.payload) {
            return state;
          }

          return {
            ...state,
            status: EOffersStatus.Failed,
          };
        },
      );
  },
});

export const {
  reducer: offersReducer,
  actions: { setDealType, setRoomTypes, resetOffers },
} = offersSlice;
